function MainEntity() {
  this.name='mainEntity';
}

export {MainEntity};
